import { gql } from "@apollo/client";
export const containersQry = gql`
{
  filteredContainers{
    id,
    referenceNumber,
    harold_number,
    buyOperationId,
    sellOperationId,
    finalMargin{
      displayedVolume
    }
    isPlannedDelivery,
    isPlannedLoading,
    photos,
    totalDeliveredTons,
    qualities{
     id 
     operationQuality {
        id
        quality { id name }
      }
   }
  }
}
`;

